import React from 'react';

interface PasswordChangeIllustrationProps {
  variant: 'success' | 'error';
  className?: string;
}

interface PasswordDotsProps {
  x: number;
  y: number;
  count: number;
  spacing: number;
  fill: string;
}

const PasswordDots = ({ x, y, count, spacing, fill }: PasswordDotsProps) => (
  <>
    {Array.from({ length: count }).map((_, index: number) => (
      <circle
        key={index}
        cx={x + index * spacing}
        cy={y}
        r={3}
        fill={fill}
      />
    ))}
  </>
);

const PasswordChangeIllustration = ({
  variant,
  className,
}: PasswordChangeIllustrationProps) => {
  if (variant === 'success') {
    return (
      <svg
        className={className}
        width="180"
        height="150"
        viewBox="0 0 180 150"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="15"
          y="45"
          width="105"
          height="75"
          rx="8"
          fill="#eeedfe"
          stroke="#cecbf6"
          strokeWidth="1"
        />
        <rect x="28" y="58" width="78" height="7" rx="3" fill="#cecbf6" />
        <PasswordDots x={32} y={80} count={8} spacing={10} fill="#afa9ec" />
        <PasswordDots x={32} y={96} count={6} spacing={10} fill="#afa9ec" />

        <rect
          x="38"
          y="22"
          width="105"
          height="75"
          rx="8"
          fill="#f0f0f8"
          stroke="#cecbf6"
          strokeWidth="1"
        />
        <rect x="51" y="35" width="78" height="7" rx="3" fill="#cecbf6" />
        <PasswordDots x={55} y={57} count={8} spacing={10} fill="#afa9ec" />
        <PasswordDots x={55} y={73} count={6} spacing={10} fill="#afa9ec" />

        <circle
          cx="148"
          cy="100"
          r="24"
          fill="#e1f5ee"
          stroke="#5dcaa5"
          strokeWidth="2"
        />
        <path
          d="M136 100l8 8 16-16"
          stroke="#0f6e56"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <rect
          x="136"
          y="60"
          width="14"
          height="11"
          rx="2"
          fill="#f1efe8"
          stroke="#d3d1c7"
          strokeWidth="1.5"
        />
        <path
          d="M139 60v-3a4 4 0 0 1 8 0v3"
          stroke="#d3d1c7"
          strokeWidth="1.5"
          fill="none"
          strokeLinecap="round"
        />
        <circle cx="143" cy="65.5" r="1.5" fill="#d3d1c7" />
      </svg>
    );
  }

  return (
    <svg
      className={className}
      width="180"
      height="150"
      viewBox="0 0 180 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="15"
        y="45"
        width="105"
        height="75"
        rx="8"
        fill="#fcebeb"
        stroke="#f7c1c1"
        strokeWidth="1"
      />
      <rect x="28" y="58" width="78" height="7" rx="3" fill="#f7c1c1" />
      <PasswordDots x={32} y={80} count={8} spacing={10} fill="#f09595" />
      <PasswordDots x={32} y={96} count={6} spacing={10} fill="#f09595" />

      <rect
        x="38"
        y="22"
        width="105"
        height="75"
        rx="8"
        fill="#fef5f5"
        stroke="#f7c1c1"
        strokeWidth="1"
      />
      <rect x="51" y="35" width="78" height="7" rx="3" fill="#f7c1c1" />
      <PasswordDots x={55} y={57} count={8} spacing={10} fill="#f09595" />
      <PasswordDots x={55} y={73} count={6} spacing={10} fill="#f09595" />

      <circle
        cx="148"
        cy="100"
        r="24"
        fill="#fcebeb"
        stroke="#e24b4a"
        strokeWidth="2"
      />
      <path
        d="M139 91l18 18M157 91l-18 18"
        stroke="#a32d2d"
        strokeWidth="2.5"
        strokeLinecap="round"
      />

      <rect
        x="136"
        y="60"
        width="14"
        height="11"
        rx="2"
        fill="#f1efe8"
        stroke="#d3d1c7"
        strokeWidth="1.5"
      />
      <path
        d="M139 60v-3a4 4 0 0 1 8 0v3"
        stroke="#d3d1c7"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
      />
      <circle cx="143" cy="65.5" r="1.5" fill="#d3d1c7" />
    </svg>
  );
};

export default PasswordChangeIllustration;
